export function Slider({ value, onValueChange, min = 1, max = 8, step = 1, className = "" }) {
  const current = Array.isArray(value) ? value[0] : value;

  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={current}
      onChange={(e) => onValueChange([Number(e.target.value)])}
      className={`w-full accent-[#6F00FF] ${className}`}
    />
  );
}
